// import { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import urls from "./routes";
import Root from "./Root";
import Layout from "./Layout";
import ErrorFallback from "./ErrorFallback";
import Articles from "./pages/Articles/Articles";
import Patterns from "./pages/Patterns/Patterns";
import NewPattern from "./pages/NewPattern/NewPattern";
import Pattern from "./pages/Pattern/Pattern";
import Article from "./pages/Article/Article";
import SignIn from "./pages/SignIn/SignIn";
import SignUp from "./pages/SignUp/SignUp";
import InviteAccepted from "./pages/InviteAccepted/InviteAccepted";
import Publishing from "./pages/Publishing/Publishing";
import IntegrationsWordpressCallback from "./pages/Publishing/IntegrationsWordpressCallback";
import Settings from "./pages/Settings/Settings";
import Lists from "./pages/Lists/Lists";
import Zapier from "./pages/Publishing/Zapier/Zapier";
import Webflow from "./pages/Publishing/Webflow/Webflow";
import Wordpress from "./pages/Publishing/Wordpress/Wordpress";
import NotFound from "./pages/NotFound/NotFound";
import WebflowOauthCallback from "./pages/Publishing/WebflowOauthCallback";
import Onboarding from "./pages/Onboarding/Onboarding";
import Webhook from "./pages/Publishing/Webhook/Webhook";
import Keywords from "./pages/Keywords/Keywords";
import Admin from "./pages/Admin/Admin";
import AdminArticle from "./pages/AdminArticle/AdminArticle";
import Shopify from "./pages/Publishing/Shopify/Shopify";
import Wix from "./pages/Publishing/Wix/Wix";
import Framer from "./pages/Publishing/Framer/Framer";
// const Articles = lazy(() => import("./pages/Articles/Articles"));
// const Patterns = lazy(() => import("./pages/Patterns/Patterns"));
// const NewPattern = lazy(() => import("./pages/NewPattern/NewPattern"));
// const Pattern = lazy(() => import("./pages/Pattern/Pattern"));
// const Article = lazy(() => import("./pages/Article/Article"));
// const SignIn = lazy(() => import("./pages/SignIn/SignIn"));
// const SignUp = lazy(() => import("./pages/SignUp/SignUp"));
// const InviteAccepted = lazy(
//   () => import("./pages/InviteAccepted/InviteAccepted"),
// );
// const Publishing = lazy(() => import("./pages/Publishing/Publishing"));
// const IntegrationsWordpressCallback = lazy(
//   () => import("./pages/Publishing/IntegrationsWordpressCallback"),
// );
// const Settings = lazy(() => import("./pages/Settings/Settings"));
// const Lists = lazy(() => import("./pages/Lists/Lists"));
// const Zapier = lazy(() => import("./pages/Publishing/Zapier/Zapier"));
// const Webflow = lazy(() => import("./pages/Publishing/Webflow/Webflow"));
// const Wordpress = lazy(() => import("./pages/Publishing/Wordpress/Wordpress"));
// const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
// const WebflowOauthCallback = lazy(
//   () => import("./pages/Publishing/WebflowOauthCallback"),
// );
// const Onboarding = lazy(() => import("./pages/Onboarding/Onboarding"));

const router = createBrowserRouter([
  {
    errorElement: <ErrorFallback />,
    element: <Root />,
    children: [
      {
        path: "/_/onboarding",
        element: <Onboarding />,
      },
      {
        path: urls.signIn,
        element: <SignIn />,
      },
      {
        path: urls.signUp,
        element: <SignUp />,
      },
      {
        path: urls.inviteAccepted,
        element: <InviteAccepted />,
      },
      {
        path: "/",
        element: <Layout />,
        children: [
          {
            path: urls.publishing.connections.root,
            element: <Publishing />,
          },
          {
            path: urls.publishing.root,
            element: <Navigate replace to={urls.publishing.connections.root} />,
          },
          {
            path: urls.publishing.connections.webflow,
            element: <Webflow />,
          },
          {
            path: urls.publishing.connections.wordpress,
            element: <Wordpress />,
          },
          {
            path: urls.publishing.connections.zapier,
            element: <Zapier />,
          },
          {
            path: urls.publishing.connections.webhook,
            element: <Webhook />,
          },
          {
            path: urls.publishing.connections.shopify,
            element: <Shopify />,
          },
          {
            path: urls.publishing.connections.wix,
            element: <Wix />,
          },
          {
            path: urls.publishing.connections.framer,
            element: <Framer />,
          },
          {
            path: urls.integrationsWordpressCallback,
            element: <IntegrationsWordpressCallback />,
          },
          {
            path: urls.webflowOauthCallback,
            element: <WebflowOauthCallback />,
          },
          {
            path: urls.articles,
            element: <Articles />,
          },
          {
            path: urls.article(":id"),
            element: <Article />,
          },
          {
            path: urls.patterns,
            element: <Patterns />,
          },
          {
            path: urls.newPattern,
            element: <NewPattern />,
          },
          {
            path: urls.pattern(":id"),
            element: <Pattern />,
          },
          {
            path: `${urls.settings.root}/:tabValue/:subTabValue?`,
            element: <Settings />,
          },
          {
            path: urls.settings.root,
            element: <Navigate replace to={urls.settings.generation.root} />,
          },
          {
            path: urls.lists,
            element: <Lists />,
          },
          {
            path: `${urls.admin.root}/:tabValue`,
            element: <Admin />,
          },
          {
            path: urls.admin.root,
            element: <Navigate replace to={urls.admin.teams} />,
          },
          {
            path: urls.admin.article(":id"),
            element: <AdminArticle />,
          },
          {
            path: `${urls.keywords.root}/:tabValue`,
            element: <Keywords />,
          },
          {
            path: urls.keywords.root,
            element: <Navigate replace to={urls.keywords.recommendations} />,
          },
          {
            index: true,
            element: <Navigate replace to={urls.articles} />,
          },
          {
            path: "*",
            element: <NotFound />,
          },
        ],
      },
    ],
  },
]);

export default router;
